import { Axios } from "../../utils/axiosMiddleware";
import { SimpleCatchError } from "../../utils/Helper";

/**
 * Contract-charge PaymentIntent. The server creates the PaymentIntent (amount +
 * GigMi fee computed server-side — the client total is display-only) and returns
 * `{ paymentIntent, ephemeralKey, customer }`. Web mounts a Payment Element with
 * the `paymentIntent` client_secret; the body is `{ contractId }` only, never an
 * amount. Returns the response data so the caller can mount <Elements>; returns
 * undefined on error (caller guards).
 */
/**
 * The server refuses a second PaymentIntent once a charge has settled for the
 * contract. That is the double-charge guard working, not a failure: the money is
 * already captured, so the caller should skip straight to accept rather than
 * strand the payer. Matched on the exact backend message
 * (`payment.service.ts` — "This contract has already been paid") so no other
 * 400 is mistaken for it.
 */
export const ALREADY_PAID_MESSAGE = "This contract has already been paid";

const isAlreadyPaid = (e) =>
  e?.response?.data?.message === ALREADY_PAID_MESSAGE;

export const createPaymentSheet = async (contractId) => {
  try {
    const response = await Axios.post("payment/payment-sheet", { contractId });
    return response?.data;
  } catch (e) {
    // Surface this one case to the caller instead of showing the raw error —
    // the payer did nothing wrong and their contract can still be accepted.
    if (isAlreadyPaid(e)) {
      return { alreadyPaid: true };
    }
    SimpleCatchError(e);
  }
};
